(function () {
  "use strict";

  const sortForceChildContainers = () => {
    document.querySelectorAll(".force-child-sort").forEach((container) => {
      const children = Array.from(container.children).filter((child) =>
        child.hasAttribute("data-sort-key")
      );

      if (children.length < 2) return;

      children
        .sort((a, b) => {
          const keyA = a.getAttribute("data-sort-key") || "";
          const keyB = b.getAttribute("data-sort-key") || "";
          return keyA.localeCompare(keyB);
        })
        .forEach((child) => container.appendChild(child));
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sortForceChildContainers);
  } else {
    sortForceChildContainers();
  }
})();
